// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CreateShipToApiParameter } from "@insite/client-framework/Services/CustomersService";
import {
  chain,
  CreateShipTo,
  DispatchShipTosReset,
} from "@insite/client-framework/Store/Pages/Addresses/Handlers/CreateShipTo";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { xngCreateShipTo } from "@pacific/App/Services/CustomersService";

type HandlerType = ApiHandler<CreateShipToApiParameter, ShipToModel | {
  successful: boolean,
  errorMessage: string,
}>;

export const XngCreateShipTo: HandlerType = async props => {
  props.apiResult = await xngCreateShipTo(props.apiParameter);
};

export const XngDispatchShipTosReset: any = (props: any) => {
    props.dispatch({
        type: "xCompanySavedAddresses/ResetDataViews",
    });
};

replaceInChain(chain, CreateShipTo, XngCreateShipTo);
addToChainAfter(chain, DispatchShipTosReset, XngDispatchShipTosReset);
